var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "integralDeduction" }, [
    _c("span", [_vm._v("积分")]),
    _vm._v(" "),
    _c("span", [
      _vm._v("抵扣" + _vm._s(_vm.goodData.maxDeductionAmount) + "元")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }